import { Divider, Form, Modal, Row } from "antd"
import { ContractDetail, ServiceContract } from "src/common/models/contract"
import { ItemData } from "../ItemData"
import { Col24 } from "src/components/Columns"
import { getInputRequiredRule } from "src/common/util"
import { CurrencyInput } from "src/components/CurrencyInput"
import { FormActionButtons } from "src/components/FormActionButtons"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "src/state/reducer"
import { updateCurrentContract } from "src/features/ServiceContract/state/action"
import { SystemDescriptions } from "src/common/descriptions"

interface Props {
    open: boolean
    onCancel: VoidFunction
    onAccept: VoidFunction
    okText: string
    cancelText: string
    itemDetail: ContractDetail
}

export type ReduxProps = {
    currentContract?: Partial<ServiceContract>
}

export const PriceModal = (props: Props) => {
    const dispatch = useDispatch()

    const [form] = Form.useForm();

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        currentContract: state.serviceContract.currentContract,
    }))

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.CREATE_SERVICE_CONTRACT

    useEffect(() => {
        form.setFieldsValue({
            price: props.itemDetail.price,
        })
    }, [])

    const onFinish = (formValues) => {
        let total: number = 0

        const newDetail = reduxProps.currentContract?.detail?.map(item => {
            if (item.ref === props.itemDetail.ref) {
                item.price = formValues.price
                item.total = formValues.price
            }
            total = total + Number(item.total)
            return item
        })

        dispatch(updateCurrentContract({
            detail: newDetail,
            total,
        }))

        props.onAccept()
    }

    const renderForm = () => {
        return <Form
            form={form}
            layout="vertical"
            requiredMark={false}
            autoComplete={'none'}
            onFinish={onFinish}
        >
            <Row gutter={[16, 8]}>
                <Col24>
                    <Form.Item
                        label={descriptions.PRICE.PRICE.LABEL}
                        name={"price"}
                        rules={[
                            getInputRequiredRule(descriptions.PRICE.PRICE.LABEL),
                        ]}
                        validateTrigger="onBlur"
                    >
                        <CurrencyInput
                            placeholder={descriptions.PRICE.PRICE.PLACEHOLDER}
                        />
                    </Form.Item>
                </Col24>
                <Col24>
                    <FormActionButtons
                        cancelText={descriptions.CANCEL_BUTTON}
                        actionText={descriptions.SAVE_BUTTON}
                        onCancel={() => {
                            form.setFieldsValue({
                                price: props.itemDetail.price,
                            })
                            props.onCancel()
                        }}
                    />
                </Col24>
            </Row>
        </Form>
    }

    return (
        <Modal
            title={descriptions.TITLE}
            centered
            open={props.open}
            width={600}
            onOk={props.onAccept}
            okText={props.okText}
            cancelText={props.cancelText}
            footer={<></>}
            closable={false}
            zIndex={1200}
            getContainer={false}
            destroyOnClose
        >
            <ItemData itemDetail={props.itemDetail} />
            <Divider />
            {renderForm()}
        </Modal>
    )
}
